import { resolve, ImResponse, doorClient, messDoorClient } from '.';
import dayjs from 'lib/dayjs';

export interface ListParams {
  orderId?: string;
  status?: Review.Status;
  star?: 'good' | 'bad';
  pageSize: number;
  offset: string;
}

export interface ListResponse {
  pageInfo: {
    pageSize: number;
    offset: string;
  };
  reviewInfos: Review.Profile[];
}

export function list(params: ListParams) {
  return resolve(
    doorClient.get<ImResponse<ListResponse>>('/overseaim-review/v1/query/review/page', {
      params,
    }),
  );
}

export interface NewListResponse {
  cursor: Review.Cursor[];
  reviewInfos: Review.Profile[];
}

export function newList(body: Review.RequestSearch) {
  const cursor = [...body.cursor];
  cursor.some((v, i) => {
    if (v.fieldName === 'spu_name' && i !== 0) {
      cursor.splice(i, 1);
      return true;
    }
    return false;
  });
  return resolve(
    doorClient.post<ImResponse<NewListResponse>>('/overseaim-hi/v1/review/search', {
      ...body,
      cursor,
    }),
  );
}

export interface DetailParams {
  commentId: string;
}

export function detail(params: DetailParams) {
  return resolve(
    doorClient.get<ImResponse<Review.Detail>>('/overseaim-review/v1/query/review/detail', {
      params,
    }),
  );
}

export interface UpdateStatusBody {
  commentId: string;
  status: Review.Status;
}

export interface ConflictResponse {
  msgCode: 409;
}

export function updateStatus(body: UpdateStatusBody) {
  return resolve(
    doorClient.post<ImResponse<ConflictResponse | undefined>>(
      '/overseaim-review/v1/update/review/status',
      body,
    ),
  );
}

export interface SyncBody {
  commentId: string;
  channel: Review.Detail['channel'];
}

export function sync(body: SyncBody) {
  return resolve(doorClient.post('/oversea-item/v1/sync/update/review', body));
}

export interface BuyerDetailParams {
  orderId: string;
  /**
   * 内部id
   */
  storeId: string;
  channel: Review.Detail['channel'];
  region: General.UpperCaseRegion;
}

export interface BuyerDetailResponse {
  buyerDetail: {
    buyerId: string;
    buyerPicture: string;
    buyerName: string;
    /**
     * 1 shopee; 2 lazada
     */
    channel: 1 | 2;
    region: General.UpperCaseRegion;
    storeName: string;
    aliasName: string;
  };
}

export function buyerDetail(params: BuyerDetailParams) {
  return resolve(
    doorClient.get<ImResponse<BuyerDetailResponse>>('/overseaim-review/v1/query/buyer/detail', {
      params,
    }),
  );
}

export interface ReplyBody {
  channel: Review.Detail['channel'];
  commentId: string;
  content: string;
}

export function reply(body: ReplyBody) {
  return resolve(
    doorClient.post<ImResponse<ConflictResponse | undefined>>(
      '/overseaim-review/v1/reply/review',
      body,
    ),
  );
}

export type StatBody = Required<
  Omit<Review.Filte, 'platform' | 'region' | 'follower' | 'storeId' | 'orderId'>
>;

export const getStatBody = (): StatBody => ({
  hasContent: 'all',
  handleStatus: ['1', '2'],
  reviewStartTime: dayjs().subtract(1, 'days').startOf('days').valueOf().toString(),
  reviewEndTime: dayjs().endOf('days').valueOf().toString(),
  reviewRating: ['1', '2', '3'],
  productRating: ['1', '2', '3'],
  sellerRating: ['1', '2'],
  logisticsRating: ['1', '2', '3'],
  spuName: '',
});

export function stat(body: StatBody) {
  return resolve(messDoorClient.post<ImResponse<Review.Stat>>('/oversea-hi/v1/review/stat', body));
}

export function exportReview(
  body: Review.Filte & {
    lang: string;
  },
) {
  return resolve(
    messDoorClient.post<ImResponse<undefined>>('/overseaim-hi/v1/review/export', body),
  );
}
